import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import { useState, type ReactElement } from 'react';

import type { Canton } from '../types';

export type CantonCardProps = {
    canton: Canton;
    checked: boolean;
    onToggle: () => void;
};

const FLAG_SX = { width: 32, height: 32, border: 1, borderColor: 'divider', borderRadius: 1, flexShrink: 0 } as const;

export function CantonCard({ canton, checked, onToggle }: CantonCardProps): ReactElement {
    const [flagFailed, setFlagFailed] = useState(false);

    return (
        <FormControlLabel
            control={<Checkbox checked={checked} onChange={onToggle} inputProps={{ 'aria-label': canton.longName }} />}
            label={
                <Stack
                    direction="row"
                    sx={{
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                    }}>
                    <span aria-hidden>{canton.shortName}</span>
                    {flagFailed ? (
                        <Box aria-hidden sx={FLAG_SX} />
                    ) : (
                        <Box
                            component="img"
                            src={`/flags/${canton.shortName}.svg`}
                            alt=""
                            aria-hidden
                            onError={() => setFlagFailed(true)}
                            sx={{ ...FLAG_SX, objectFit: 'cover' }}
                        />
                    )}
                </Stack>
            }
            sx={{
                width: '100%',
                m: 0,
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
                px: 1.5,
                py: 1.5,
                cursor: 'pointer',
                '& .MuiFormControlLabel-label': { flex: 1 },
            }}
        />
    );
}
